import type { ReactNode } from "react";
import type { SelectionRange, SpreadsheetCell } from "./types";

/**
 * A button on the selected range's top-right cell: a click runs the action,
 * a press and move drags the range out of the grid, onto a drop zone the app
 * registers in an enclosing dnd-kit `DndContext`. The payload lands in
 * `active.data.current`.
 */
export interface SpreadsheetRangeAction {
    /** Tooltip and accessible name, e.g. "Add to chat". */
    label: string;
    icon: ReactNode;
    onClick: () => void;
    /** Payload for dragging the range out through an enclosing dnd-kit `DndContext`. */
    dragData: object;
}

/** The cell that carries the range action button: the range's top-right cell, or the focused cell with no range. */
export function getRangeActionCell({
    selectedCell,
    selectionRange,
}: {
    selectedCell: SpreadsheetCell | null;
    selectionRange: SelectionRange;
}): SpreadsheetCell | null {
    const { start, end } = selectionRange;
    if (start && end) {
        return {
            row: Math.min(start.row, end.row),
            col: Math.max(start.col, end.col),
        };
    }
    return selectedCell;
}
